export const createFacebookShareUrl = ({currentUrl}: {currentUrl: string}) => {
  return `http://www.facebook.com/share.php?u=${encodeURIComponent(currentUrl)}`;
};

export const createXShareUrl = ({
  currentUrl,
  title,
}: {
  currentUrl: string;
  title: string;
}) => {
  return `https://twitter.com/intent/tweet?text=${encodeURIComponent(title)}&url=${encodeURIComponent(currentUrl)}`;
};

export const createHatenaShareUrl = ({currentUrl}: {currentUrl: string}) => {
  return `http://b.hatena.ne.jp/entry/${encodeURIComponent(currentUrl)}`;
};

export const createLineShareUrl = ({
  currentUrl,
  title,
}: {
  currentUrl: string;
  title: string;
}) => {
  return `https://line.me/R/msg/text/?${encodeURI(title)}%0A${encodeURIComponent(currentUrl)}`;
};

export const createPocketShareUrl = ({
  currentUrl,
  title,
}: {
  currentUrl: string;
  title: string;
}) => {
  return `http://getpocket.com/edit?url=${encodeURIComponent(currentUrl)}&title=${encodeURI(title)}`;
};
